module.exports = "- Announce success.\n"